import React from 'react';

import { Paper, Radio } from '@mui/material';
import { useToggle } from 'react-use';
import classNames from 'classnames';

import { LbFormControlLabel } from '@infoods/lifebase-ui';

import classes from './MealRow.module.scss';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../../../shared/components/table-components';
import { MealInfo } from './MealInfo/MealInfo';
import { PredefinedMealPlan } from '../../../../../interfaces/MealPlan';
import { MealNutrients } from './MealNutrients/MealNutrients';
import { OpenCloseArrow } from '../../../../../../shared/components/ui-components';
import { getEnumArray } from '../../../../../../shared/utils/jsUtils';
import {
  REGULAR_MEAL_NAME,
  RegularMealName,
} from '../../../../../../shared/constants/mealNames';

type MealRowProps = {
  mealPlan: PredefinedMealPlan;
};
const meals: RegularMealName[] = getEnumArray(REGULAR_MEAL_NAME);

const MealRow = ({ mealPlan }: MealRowProps) => {
  const [isMealInfoOpen, toggleMealInfoOpen] = useToggle(false);

  const mealRowClasses = classNames(classes.mealRow, {
    [classes.mealInfoIsOpen]: isMealInfoOpen,
  });

  const { total, name, id } = mealPlan;

  return (
    <>
      <GridTableRow
        variant="header"
        className={mealRowClasses}
        onClick={toggleMealInfoOpen}
      >
        <GridTableCell>
          <LbFormControlLabel
            onClick={(event) => event.stopPropagation()}
            value={id}
            control={<Radio />}
            className={classes.mealNameCell}
            label={name}
          />
        </GridTableCell>
        <MealNutrients nutrientsInfo={total} />
        <GridTableCell justify="end">
          <OpenCloseArrow open={isMealInfoOpen} />
        </GridTableCell>
      </GridTableRow>
      {isMealInfoOpen && (
        <Paper variant="roundedBox" className={classes.mealInfoBox}>
          {meals.map((meal) => (
            <MealInfo meal={meal} nutrientsInfo={mealPlan[meal]} key={meal} />
          ))}
        </Paper>
      )}
    </>
  );
};

export { MealRow };
